import React from 'react'
import NavBars from '../components/NavBars'
import { Footer } from '../components/Footer'

function PrivacyPolicy() {
  return (
    <div className="d-flex flex-column min-vh-100">
        <NavBars/>
        <div className='container spacer flex-grow-1'>
            <h3>Privacy Policy</h3>
            <p><strong>Effective Date:</strong> February 9, 2025</p>

            <p>RentSim Connect respects your privacy and is committed to protecting your personal information.</p>
            <p>This Privacy Policy explains how we collect, use, store, and protect your information.</p>

            <h5>1. Information We Collect</h5>
            <p>We may collect:</p>
            <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Billing information</li>
                <li>Device information</li>
                <li>IP address</li>
                <li>Order history</li>
                <li>Usage and website analytics data</li>
            </ul>
            <p>We only collect information reasonably necessary to provide and improve our services.</p>

            <h5>2. How We Use Information</h5>
            <p>Your information may be used to:</p>
            <ul>
                <li>Process orders</li>
                <li>Deliver eSIM services</li>
                <li>Provide customer support</li>
                <li>Send account updates</li>
                <li>Improve website performance</li>
                <li>Prevent fraud and unauthorized activity</li>
                <li>Provide marketing communications where permitted</li>
            </ul>

            <h5>3. Information Sharing</h5>
            <p>RentSim Connect does not sell customer personal information to third parties.</p>
            <p>We may share information only with:</p>
            <ul>
                <li>Trusted service providers necessary to operate our business</li>
                <li>Telecommunications carriers and infrastructure partners</li>
                <li>Payment processors</li>
                <li>Legal authorities when required by law</li>
                <li>Our affiliated sister company, BuySim Connect, for operational and customer service purposes</li>
            </ul>
            <p>All third parties are expected to maintain appropriate security and confidentiality protections.</p>

            <h5>4. Payment Security</h5>
            <p>Payments are securely processed through reputable third-party payment platforms utilizing advanced encryption and fraud prevention technologies.</p>
            <p>RentSim Connect does not directly store complete payment card information.</p>

            <h5>5. Data Security</h5>
            <p>We implement commercially reasonable administrative, technical, and physical safeguards designed to protect customer information against unauthorized access, disclosure, or misuse.</p>
            <p>However, no online transmission or storage system can be guaranteed 100% secure.</p>

            <h5>6. Cookies and Analytics</h5>
            <p>Our website may use cookies, analytics tools, and similar technologies to:</p>
            <ul>
                <li>Improve user experience</li>
                <li>Analyze traffic and usage</li>
                <li>Personalize website functionality</li>
            </ul>
            <p>Users may disable cookies through browser settings.</p>

            <h5>7. Marketing Communications</h5>
            <p>Customers may receive promotional emails or updates from RentSim Connect or BuySim Connect.</p>
            <p>Users may unsubscribe from marketing communications at any time using the unsubscribe link in emails.</p>

            <h5>8. International Users</h5>
            <p>Because our services support international travel, your information may be processed in multiple countries where our partners or providers operate.</p>

            <h5>9. Your Rights</h5>
            <p>Depending on your jurisdiction, you may have rights to:</p>
            <ul>
                <li>Access your information</li>
                <li>Request corrections</li>
                <li>Request deletion</li>
                <li>Opt out of marketing communications and that must be done by doing so via email to rentsimconnect@gmail.com</li>
            </ul>
            <p>Requests may be submitted through our support channels in email above or web form.</p>

            <h5>10. Children’s Privacy</h5>
            <p>Our services are not directed to children under 18 years of age or of legal age, and we do not knowingly collect personal information from children.</p>

            <h5>11. Changes to This Policy</h5>
            <p>We may update this Privacy Policy periodically. Updated versions will be posted on our website with a revised effective date.</p>

            <h5>12. Contact Us</h5>
            <p>For privacy-related questions or requests, contact:</p>
            <p>
                <strong>Privacy Team</strong><br/>
                RentSim Connect & BuySim Connect<br/>
            </p>
        </div>
        <Footer/>
    </div>
  )
}

export default PrivacyPolicy